import { Cookie } from '@common-vue/util/src/modules/cookie';

export default function getCSLCookie() {
  const bopsPickupStore = Cookie.get('BOPSPICKUPSTORE', 'MISCGCs');
  const cslCookie = Cookie.get('CSL') || bopsPickupStore;
  /* istanbul ignore else */
  if (Number.isNaN(Number(cslCookie))) {
    return Cookie.get('CSL');
  }
  return cslCookie;
}
